import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';
import './style.css';

function ResetPassword({ onComplete }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleBackToLogin = () => {
    if (onComplete) {
      onComplete();
    } else {
      window.location.href = '/';
    }
  };

  useEffect(() => {
    // Verifica se há um token de recuperação válido
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        console.log('❌ Nenhuma sessão de recuperação encontrada');
        setError('Link inválido ou expirado. Solicite um novo link de recuperação.');
      } else {
        console.log('✅ Sessão de recuperação válida');
      }
    };

    checkSession();
  }, []);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validações
    if (!password || !confirmPassword) {
      setError('Por favor, preencha todos os campos');
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setError('As senhas não coincidem');
      setLoading(false);
      return;
    }

    if (password.length < 6) {
      setError('A senha deve ter no mínimo 6 caracteres');
      setLoading(false);
      return;
    }

    try {
      console.log('🔐 Redefinindo senha...');

      const { data, error: updateError } = await supabase.auth.updateUser({
        password: password
      });

      if (updateError) {
        console.error('❌ Erro ao redefinir senha:', updateError);
        
        if (updateError.message.includes('same as the old password')) {
          setError('A nova senha não pode ser igual à senha anterior');
        } else if (updateError.message.includes('session')) {
          setError('Sessão expirada. Solicite um novo link de recuperação.');
        } else {
          setError('Erro ao redefinir senha: ' + updateError.message);
        }
        setLoading(false);
        return;
      }

      console.log('✅ Senha redefinida com sucesso!');
      setSuccess(true);

      // Redireciona para login após 3 segundos
      setTimeout(() => {
        handleBackToLogin();
      }, 3000);

    } catch (err) {
      console.error('💥 Erro geral:', err);
      setError('Erro ao processar solicitação. Tente novamente.');
      setLoading(false);
    }
  };

  return (
    <div className="orkut-login-container">
      <div className="orkut-login-card">
        <div className="orkut-header">
          <img 
            src="/logo.png" 
            alt="ToNetwork Logo" 
            style={{ width: '60px', height: '60px' }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
          <h1>ToNetwork</h1>
        </div>

        {!success ? (
          <form className="orkut-login-form" onSubmit={handleResetPassword}>
            <h2>Redefinir Senha</h2>
            <p style={{ 
              fontSize: '0.9em', 
              color: '#666', 
              marginBottom: '20px',
              lineHeight: '1.5'
            }}>
              Digite sua nova senha abaixo.
            </p>
            
            <input
              type="password"
              placeholder="Nova senha (mínimo 6 caracteres)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              required
            />
            
            <input
              type="password"
              placeholder="Confirme a nova senha"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={loading}
              required
            />
            
            <button 
              type="submit" 
              className="orkut-btn-primary"
              disabled={loading}
            >
              {loading ? 'Redefinindo...' : 'Redefinir Senha'}
            </button>
            
            {error && <div className="orkut-error">{error}</div>}
            
            <div className="orkut-login-switch" style={{ marginTop: '16px' }}>
              <button 
                type="button" 
                onClick={handleBackToLogin}
                disabled={loading}
              >
                ← Voltar para o login
              </button>
            </div>
          </form>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px 20px' }}>
            <div className="orkut-success">
              ✅ Senha redefinida com sucesso!
            </div>
            <p style={{ 
              marginTop: '20px', 
              color: '#666',
              fontSize: '0.95em'
            }}>
              Redirecionando para o login...
            </p>
          </div>
        )}
      </div>

      <div className="orkut-footer">
        <p>ToNetwork - Conectando estudantes universitários</p>
      </div>
    </div>
  );
}

export default ResetPassword;
